export enum ThumbSize {
  Small = 300,
  Mid = 900,
  Large = 1200
}
export const firebaseImage = (path?: string, thumbnailSize?: ThumbSize): string => {
  const storageBucket = process.env.EXPO_PUBLIC_FB_STORAGE_BUCKET;
  if (!path) return '';

  if (!thumbnailSize) {
    return `https://firebasestorage.googleapis.com/v0/b/${storageBucket}/o/${encodeURIComponent(path)}?alt=media`;
  }

  const parts = path.split('/');
  const fileName = parts.pop() || '';
  const folder = parts.join('/');

  // Detect if the last dot is a true extension because name can contain dots on timestamps or extensions at the end
  const dotIndex = fileName.lastIndexOf('.');
  const knownExts = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'heic', 'avif'];

  let name = fileName;
  let ext = '';

  if (dotIndex >= 0) {
    const possibleExt = fileName.slice(dotIndex + 1).toLowerCase();
    if (knownExts.includes(possibleExt)) {
      name = fileName.slice(0, dotIndex);
      ext = fileName.slice(dotIndex);
    }
  }

  const resizedPath = `${folder}/resize-images/${name}_${thumbnailSize}x${thumbnailSize}${ext}`;

  return `https://firebasestorage.googleapis.com/v0/b/${storageBucket}/o/${encodeURIComponent(resizedPath)}?alt=media`;
};

export const safeJsonParseArray = (input: string): string[] => {
  try {
    const cleanedInput = input.replace(/\\\"/g, '"').replace(/^"|"$/g, '');
    const parsed = JSON.parse(cleanedInput);

    if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
      return parsed;
    } else {
      throw new Error('Parsed value is not a string array');
    }
  } catch {
    return [input];
  }
};
